import { Select, Typography, Table, message, Button, Input } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { serverUrl } from "../../../../nestserver";
import LiveBusMap from "./LiveBusMap";

const AdminTrackingStatus = () => {
  const { Option } = Select;
  const { Title } = Typography;
  const [routeId, setRouteId] = useState();
  const [routeData, setRouteData] = useState(null);
  const [alertReason, setAlertReason] = useState("");
  const queryClient = useQueryClient();

  // Fetch all routes
  async function fetchRoute() {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/routes/v2`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const routes = useQuery(["routes/v2"], () => fetchRoute());

  useEffect(() => {
    if (routeId) {
      const selectedRoute = routes?.data?.result?.data?.find(
        (data) => data?._id === routeId,
      );
      setRouteData(selectedRoute);
    } else {
      setRouteData(null);
    }
  }, [routeId, routes]);

  const onFinish = (values) => {
    const payload = {
      alert: alertReason,
      route_id: routeId,
    };

    if (routeId) {
      axios
        .post(serverUrl + "/routes/v2/alert", payload, {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        })
        .then((res) => {
          queryClient.invalidateQueries(["routes/v2/alerts", routeId]);
          message.success(res?.data?.result?.message);
          setAlertReason("");
        })
        .catch((err) => {
          message.error(err?.response?.data?.message);
          console.log("err", err);
        });
    }
  };

  async function fetchIssues(id) {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/routes/v2/${id}/alerts`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }

  const issueDetails = useQuery(
    ["routes/v2/alerts", routeId],
    () => routeId && fetchIssues(routeId),
    {
      enabled: !!routeId,
    },
  );

  const columnsLog = [
    {
      title: "Date",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record}
          style={{ color: "#111111" }}
          className="text-base text-center"
        >
          {record?.createdAt
            ? moment(record?.createdAt).format("DD/MM/YYYY")
            : "-"}
        </div>
      ),
    },
    {
      title: "Alert",
      dataIndex: [],
      key: "",
      align: "center",
      render: (record) => {
        return (
          <div
            key={record}
            style={{ color: "#111111" }}
            className="text-base text-center capitalize"
          >
            {record?.alert}
          </div>
        );
      },
    },
  ];

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className=" bg-white drop-shadow-md p-8 w-full"
      >
        <div className="text-2xl text-orange-500 font-semibold mb-6">
          Live Tracking Status
        </div>
        <div className="flex flex-col w-310">
          <h6 className=" text-base pb-3">Route: &nbsp;</h6>
          <Select
            allowClear
            showSearch
            showArrow
            placeholder="Select Route (or leave empty for Fleet View)"
            className=" bg-gray-300 capitalize"
            style={{
              border: "6px",
              backgroundColor: "#EBEBEB",
              width: "90%",
            }}
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(value) => setRouteId(value)}
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {routes?.isSuccess &&
              routes?.data?.result?.data?.map((data) => {
                return (
                  <Option key={data._id} value={data._id}>
                    {data?.name}
                  </Option>
                );
              })}
          </Select>
        </div>

        <div className="pt-4">
          <LiveBusMap
            routeData={routeData}
            routeId={routeId}
            routes={routes?.data?.result?.data || []}
          />
        </div>

        <Title level={5} className="pt-8">
          Alert Log
        </Title>
        <Input.TextArea
          rows={3}
          placeholder="Reason"
          className="w-full border focus:outline-none resize-none"
          maxLength={100}
          value={alertReason}
          onChange={(e) => setAlertReason(e.target.value)}
        />
        <div className="pt-4">
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            className="text-white"
            onClick={onFinish}
          >
            Send
          </Button>
        </div>
        <div className="py-5">
          <Table
            rowKey="_id"
            columns={columnsLog}
            dataSource={
              issueDetails?.isSuccess &&
              issueDetails?.data?.result?.data?.length > 0 &&
              issueDetails?.data?.result?.data
                ? issueDetails?.data?.result?.data
                : []
            }
            pagination={true}
            loading={issueDetails?.isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminTrackingStatus;
